
import setLabels from './setLabels/index.vue'
import patientLabels from './patientLabels/index.vue'
import Uheader from './Uheader.vue'
import medicalRecord from './MedicalRecord.vue'
import prescriptionPrint from './prescriptionPrint.vue'
import medicalRecord2 from './MedicalRecord2.vue'
import udate from './udate.vue'
import layer from './layer.vue'
import patientInfo from './patientInfo/patientInfo.vue'
import dateSelect from './dateSelect.vue'
import courseTreatment from './courseTreatment/index.vue'
import newsCenter from './newsCenter.vue'
import prescriptionSelect from './prescriptionSelect.vue'
import Ucomplete from './Ucomplete.vue'
import uArchives from './uArchives.vue'

import camera21 from './camera/camera21.vue'
import camera3 from './camera/camera3.vue'
import medicalRecordPrint from './medicalRecordPrint.vue'
import notice from './notice.vue'
import empty from './empty.vue'
import uSpin from './uSpin.vue'
import symptomDropdown from './symptomDropdown/index.vue'
import drugsFormat from './drugs_format.vue'
import xAutoComplete from './xAutoComplete.vue'
import symptomChanges from './symptomChanges.vue'
import uformCreate from './uformCreate/index.vue'
import editWin from './editWin/index.vue'
import westernMedicineDiseaseName from './westernMedicineDiseaseName/index.vue'
import dateTimePicker from './dateTimePicker/index.vue'
import { WebCam } from "./webcam";
import utabs from './utabs.vue'
import UserAutoComplete from './UserAutoComplete.vue'
import passwordInput from "./passwordInput.vue";
import causeSelection from "./causeSelection/index.vue";
import diseaseCourseInformation from "./diseaseCourseInformation/index.vue";
import remarksInput from "./remarksInput.vue";
import hobby from "./hobby.vue";
import doctorAdvice from "./doctorAdvice.vue";
import healingMarkers from "./healingMarkers/index.vue";
import applyForAddingLabels from "./applyForAddingLabels/index.vue";
import message from "./message/index.vue";
import tabooInfo from "./tabooInfo/index.vue";
import etiologicalAnalysisWorkFlow from "./etiologicalAnalysisWorkFlow/index.vue";
import patientName from "./patientName/index.vue";
import feedbackRecord from "./feedbackRecord/index.vue";
import quickQuery from "./quickQuery/index.vue";
import appletWesternInput from "./appletWesternInput/index.vue";
import messageBox from "./messageBox/index.vue";
import uploadPic from "./uploadPic/index.vue";
import dialecticalSelect from "./dialecticalSelect/index.vue";
import iImg from "./iImg/index.vue";
import medicalConsultationInformation from "./medicalConsultationInformation/index.vue";
import FloatMenu from "./floatMenu/index.vue";
import successfulMedicalCase from "./successfulMedicalCase.vue";
import markGood from "./markGood/index.vue";
import markGoodInfo from "./markGood/markGoodInfo.vue";
import QuarterCompare from "./QuarterCompare/index.vue";
import wuxingCompare from "./wuxingCompare/index.vue";
import WCModal from "./wuxingCompare/WCModal.vue";

let coms = {
    WCModal,
    wuxingCompare,
    QuarterCompare,
    markGoodInfo,
    markGood,
    successfulMedicalCase,
    FloatMenu,
    dialecticalSelect,
    iImg,
    uploadPic,
    appletWesternInput,
    medicalConsultationInformation,
    messageBox,
    quickQuery,
    patientName,
    tabooInfo,
    etiologicalAnalysisWorkFlow,
    feedbackRecord,
    message,
    healingMarkers,
    applyForAddingLabels,
    doctorAdvice,
    hobby,
    remarksInput,
    diseaseCourseInformation,
    causeSelection,
    patientLabels,
    setLabels,
    Uheader,
    medicalRecord,
    prescriptionPrint,
    medicalRecord2,
    udate,
    layer,
    patientInfo,
    dateSelect,
    courseTreatment,
    newsCenter,
    prescriptionSelect,
    Ucomplete,
    uArchives,
    camera21,
    camera3,
    medicalRecordPrint,
    notice,
    empty,
    uSpin,
    symptomDropdown,
    drugsFormat,
    xAutoComplete,
    symptomChanges,
    uformCreate,
    editWin,
    westernMedicineDiseaseName,
    dateTimePicker,
    WebCam,
    utabs,
    UserAutoComplete,
    passwordInput,
}

export default (Vue) => {
    for (const [key, component] of Object.entries(coms)) {
        component && Vue.component(key, component)
    }
}
